import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'bergh-alert-link-unlink',
    templateUrl: './alert-link-unlink.component.html',
    styleUrls: ['./alert-link-unlink.component.scss'],
    standalone: false
})
export class AlertLinkUnlinkComponent implements OnInit {
  @Input() isLink;
  @Input() popUpAllType;

  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
  @Output() isConfirmLink: EventEmitter<boolean> = new EventEmitter();
  @Output() isConfirmUnlink: EventEmitter<boolean> = new EventEmitter();
  @Output() isConfirmAllLink: EventEmitter<boolean> = new EventEmitter();
  @Output() isConfirmAllUnlink: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

}
